export default {
  date (isoString) {
    let date = new Date(isoString)
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
  },
  datetime (isoString) {
    let date = new Date(isoString)
    return this.date(isoString) + ' ' + date.getHours() + ':' + date.getMinutes()
  }
}
